import React from 'react';
import QR from 'qrcode.react';
import { connect } from 'react-redux';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';

import { fetchDevice } from '../store/actions/deviceActions';
import { fetchUser } from '../store/actions/userActions';
import { mobileDeviceId } from '../store/actions/appActions';
import { fetchFeaturedPlaylist, fetchHomePlaylist, fetchActivePlaylist, fetchMyPlaylist, fetchFollowedCollection } from '../store/actions/playlistActions';
import { fetchSubscription } from '../store/actions/subscriptionActions';
import { FETCH_DEVICE_SUCCESS } from '../store/constants/deviceConstants';
import { BACK, ENTER, LEFT, RIGHT, EXIT } from '../util/remoteButtons';
import { fireAnalytics } from './utils';

export class Connect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 'step1',
      name: null,
      open: false
    };
    this.selectedBtn = 'None';
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.backButtonText = 'Skip';
    this.nextButtonText = 'Connect';
  }

  async componentDidMount() {
    const { next } = this.refs;
    next.focus();
    let pairInterval = null;
    const pair = async () => {
      try {
        const deviceResult = await this.props.fetchDevice(this.props.app.tizenDeviceId);
        if (deviceResult.errors === 'Error') {
          setTimeout(() => {
            this.props.history.push('/error');
          }, 10);
          return;
        }
        if (deviceResult.type === FETCH_DEVICE_SUCCESS) {
          clearInterval(pairInterval);
          this.setState({ step: 'step5' });
          document.getElementById("pairDiv").style.background = "#009D3F";
          this.refs.next.focus();
          this.selectedBtn = 'Next';
          const emailId = deviceResult.payload._embedded.user.email;
          const userId = deviceResult.payload._embedded.user.id;
          fireAnalytics('Pair', 'Display Paired at Step 4', emailId);
          this.setState({ name: deviceResult.payload.name });
          await this.props.mobileDeviceId(userId);
          // TODO: Move this into a redux action. Functionality is duplicated on the splash page.
          const response = await bdReq.post('/emailLogin', { emailId });
          if (response.success) {
            bdAuth._storeToken(response.body);
          }

          const fetchUser = await this.props.fetchUser();
          if (fetchUser.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchSubscription = await this.props.fetchSubscription();
          if (fetchSubscription.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchFeaturedPlaylist = await this.props.fetchFeaturedPlaylist();
          if (fetchFeaturedPlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchMyPlaylist = await this.props.fetchMyPlaylist();
          if (fetchMyPlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchFollowedCollection = await this.props.fetchFollowedCollection();
          if (fetchFollowedCollection.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchHomePlaylist = await this.props.fetchHomePlaylist();
          if (fetchHomePlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
          const fetchActivePlaylist = await this.props.fetchActivePlaylist('Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
          if (fetchActivePlaylist.errors === 'Error') {
            setTimeout(() => {
              this.props.history.push('/error');
            }, 10);
            return;
          }
        }
      } catch (e) {
        console.log(e);
      }
    };

    pairInterval = setInterval(() => pair(), 3000);

    this.selectedBtn = 'Next';
    return () => {
      clearInterval(pairInterval);
    };
  }

  handleKeyDown(e) {
    e.stopPropagation();
    switch (e.which) {
      case RIGHT:
        if (this.state.open) {
          document.getElementById('No').style.background = '';
          document.getElementById('yes').style.background =
            '#910048';
          setTimeout(() => {
            const { yes } = this.refs;
            yes.focus();
          }, 300);
          this.selectedBtn = 'Yes';
        } else {
          this.refs.next.focus();
          this.selectedBtn = 'Next';
        }
        break;
      case LEFT:
        if (this.state.open) {
          document.getElementById('yes').style.background = '';
          document.getElementById('No').style.background = '#910048';
          setTimeout(() => {
            const { no } = this.refs;
            no.focus();
          }, 300);
          this.selectedBtn = 'No';
        } else {
          this.refs.back.focus();
          this.selectedBtn = 'Back';
        }
        break;
      case ENTER:
        if (this.selectedBtn === 'No') {
          this.setState({ open: false });
          this.refs.next.focus();
          this.selectedBtn = 'Next';
        } else if (this.selectedBtn === 'Yes') {
          tizen.application.getCurrentApplication().exit();
        } else if (this.selectedBtn === 'Next') {
          if (this.state.step === 'step1') {
            fireAnalytics('Navigation', 'At Step 1');
            this.nextButtonText = 'Next';
            this.backButtonText = 'Back';
            this.setState({ step: 'step2' });
            this.refs.next.focus();
          } else if (this.state.step === 'step2') {
            fireAnalytics('Navigation', 'At Step 2');
            this.refs.next.focus();
            this.selectedBtn = 'Next';
            this.setState({ step: 'step3' });
          } else if (this.state.step === 'step3') {
            fireAnalytics('Navigation', 'At Step 3 to Pair Display');
            this.refs.next.focus();
            this.selectedBtn = 'Next';
            this.setState({ step: 'step4' });
          } else if (this.state.step === 'step5') {
            fireAnalytics('Navigation', 'Paired Display Details');
            document.getElementById("pairDiv").style.background = "#111111";
            this.refs.next.focus();
            this.selectedBtn = 'Next';
            this.setState({ step: 'step6' });
          } else if (this.state.step === 'step6') {
            fireAnalytics('Navigation', 'At Step 4');
            this.nextButtonText = 'Complete Setup';
            this.refs.next.focus();
            this.setState({ step: 'step7' });
          } else if (this.state.step === 'step7') {
            fireAnalytics('Navigation', 'Setup Complete, navigating to player');
            this.props.history.push('/playlist/Y0d4aGVXeHBjM1E9NzlmMzdkNzAtYTlmZC0xMWU3LWI5ZDMtNTU2OGIzMzVhMDUx');
          }
        } else if (this.selectedBtn === 'Back') {
          this.handleBack();
        }
        break;
      case 27: // ///////////////For Esc Keyboard Key
      case BACK:
        if (this.state.open) {
          this.setState({ open: !this.state.open });
          this.selectedBtn = 'Next';
          this.refs.next.focus();
        } else if (this.state.step === 'step1' || this.state.step === 'step5' || this.state.step === 'step6') {
          this.setState({ open: !this.state.open });
          setTimeout(() => {
            if (this.state.open) {
              document.getElementById('yes').style.background = '';
              document.getElementById('No').style.background = '#910048';
              setTimeout(() => {
                const { no } = this.refs;
                no.focus();
              }, 300);
              this.selectedBtn = 'No';
            }
          }, 200);
        } else {
          this.handleBack();
        }
        break;
      case EXIT:
        this.setState({ open: !this.state.open });
        setTimeout(() => {
          if (this.state.open) {
            document.getElementById('yes').style.background = '';
            document.getElementById('No').style.background = '#910048';
            setTimeout(() => {
              const { no } = this.refs;
              no.focus();
            }, 300);
            this.selectedBtn = 'No';
          }
          else {
            this.refs.next.focus();
            this.selectedBtn = 'Next';
          }
        }, 200);
    }
  }

  handleBack() {
    if (this.state.step === 'step1') {
      fireAnalytics('Navigation', 'Skipped To Video');
      this.props.history.push('/featured');
    } else if (this.state.step === 'step2') {
      fireAnalytics('Navigation', 'Back to Step 1');
      this.nextButtonText = 'Connect';
      this.backButtonText = 'Skip';
      this.refs.back.focus();
      this.selectedBtn = 'Back';
      this.setState({ step: 'step1' });
    } else if (this.state.step === 'step3') {
      fireAnalytics('Navigation', 'Back to Step 2');
      this.refs.back.focus();
      this.selectedBtn = 'Back';
      this.setState({ step: 'step2' });
    } else if (this.state.step === 'step4') {
      fireAnalytics('Navigation', 'Back to Step 3');
      this.refs.back.focus();
      this.selectedBtn = 'Back';
      this.setState({ step: 'step3' });
    } else if (this.state.step === 'step7') {
      fireAnalytics('Navigation', 'Back to Step 4');
      this.nextButtonText = 'Next';
      this.selectedBtn = 'Back';
      this.refs.back.focus();
      this.setState({ step: 'step6' });
    }
  }

  render() {
    return (
      <div className="connect-wrapper" onKeyDown={this.handleKeyDown}>
        {this.state.open ? (
          <div id="models" className="reg-response-modal" style={{ position: 'absolute', zIndex: '9999' }}>
            <div className="model" style={{ width: '40%', backgroundColor: 'black', color: 'white', borderRadius: '15px' }}>
              <img className="Logo2" src="/assets/img/blackdove-logo-2020.png" alt="" style={{ width: '50%', paddingTop: '6%' }} />
              <h2 style={{ marginBottom: '2%' }}>Do you want to exit?</h2>
              <button
                ref="no"
                id="No"
                onClick={() => {
                  this.setState({ open: false });
                }}
                style={{ background: '#910048' }}
                className="exitPopup"
              >No
              </button>
              <button
                ref="yes"
                id="yes"
                style={{ marginLeft: '2%' }}
                className="exitPopup"
              >Yes
              </button>
            </div>
          </div>
        ) : null}
        {this.state.step === 'step4' || this.state.step === 'step5' || this.state.step === 'step6' ?
          <div id="pairDiv" className="connect-wrapper-pairdiv">
            {this.state.step === 'step4' ? <div className="connect-wrapper-pairdiv-pairtext"><h3>SCAN THIS QR CODE</h3>Follow the actions shown on the phone on the right to scan and pair your display</div> : null}
            {this.state.step === 'step5' ? <div className="connect-wrapper-pairdiv-pairtext" style={{ marginTop: "70%" }}><img src="/assets/img/success.png" /><h3>DISPLAY PAIRED SUCCESSFULLY</h3></div> : null}
            {this.state.step === 'step6' ? <div className="connect-wrapper-pairdiv-pairtext"><h3>DISPLAY PAIRED</h3>Device Name: {this.state.name} <br /> Device ID : {this.props.app.tizenDeviceId}</div> : null}
            {this.state.step === 'step4' || this.state.step === 'step6' ? <div className="connect-wrapper-pairdiv-qrwrapper">
              <QR className="connect-wrapper-pairdiv-qrwrapper-QRCode" value={this.props.app.tizenDeviceId} size={270} renderAs="svg" />
              {this.state.step === 'step6' ? <img className="connect-wrapper-pairdiv-qrwrapper-imgwrapper" src="/assets/img/blackdovelogo.png" alt="" /> : null}
            </div> : null}
          </div> : null}
        <div className="connect-wrapper-imgdiv">
          <img className="connect-wrapper-imgdiv-img" src="/assets/img/onBoarding.png" alt="" />
        </div>
        {this.state.step === 'step1' ? <img className="connect-wrapper-iphone" src="/assets/img/iPhone_12_Pro.png" alt="" /> : null}
        {this.state.step === 'step2' ? <img className="connect-wrapper-iphone1" src="/assets/img/iPhone.png" alt="" /> : null}
        {this.state.step === 'step3' || this.state.step === 'step7' ? <img className="connect-wrapper-iphone2" src="/assets/img/iPhone.png" alt="" /> : null}
        {this.state.step === 'step4' || this.state.step === 'step5' || this.state.step === 'step6' ? <img className="connect-wrapper-iphone3" src="/assets/img/iPhone.png" alt="" /> : null}

        {this.state.step === 'step2' ? (
          <div className="connect-wrapper-badges">
            <div className="connect-wrapper-badges-appstore">
              <div className="connect-wrapper-badges-appstore-logowrapper">
                <img className="connect-wrapper-badges-appstore-logowrapper-img" src="/assets/img/applelogo.png" alt="" />
              </div>
              <div className="connect-wrapper-badges-appstore-contentwrapper">
                <span className="connect-wrapper-badges-appstore-contentwrapper-text">Download on the</span><br />
                <span className="connect-wrapper-badges-appstore-contentwrapper-textwrapper">App Store</span>
              </div>
            </div>
          </div>
        ) : null}
        <div className="connect-wrapper-infodiv">
          {/* step-1 */}
          {this.state.step === 'step1' ? (
            <div className="connect-wrapper-infodiv-contentdisplay">
              <div className="connect-wrapper-infodiv-contentdisplay-connectWrapper">
                CONNECT YOUR DISPLAY
              </div>
              <div className="connect-wrapper-infodiv-contentdisplay-pairWrapper">
                Pair this display with the mobile companion app to discover, collect
                and display new media artwork from around the world. Connect now in 4 easy steps
              </div>
            </div>
          ) : null}
          {/* step-2 */}
          {this.state.step === 'step2' ? (
            <div className="connect-wrapper-infodiv-contentdisplay">
              <div className="connect-wrapper-infodiv-contentdisplay-connectWrapper">
                STEP 1: DOWNLOAD THE MOBILE APP
              </div>
              <div className="connect-wrapper-infodiv-contentdisplay-pairWrapper">
                The mobile app is the perfect companion to discover, collect and  share the newest artworks. Use the app to showcase art that speaks to you on displays across your home or business.
              </div>
            </div>
          ) : null}
          {/* step-3 */}
          {this.state.step === 'step3' ? (
            <div className="connect-wrapper-infodiv-contentdisplay">
              <div className="connect-wrapper-infodiv-contentdisplay-connectWrapper">
                STEP 2: CREATE AN ACCOUNT/LOGIN
              </div>
              <div className="connect-wrapper-infodiv-contentdisplay-pairWrapper">
                Sign up to create an account with Blackdove. if you already have an account please login using your credentails.
              </div>
            </div>
          ) : null}
          {/* step-4 & step-5 & step-6 */}
          {this.state.step === 'step4' || this.state.step === 'step5' || this.state.step === 'step6' ? (
            <div className="connect-wrapper-infodiv-contentdisplay" style={{ marginLeft: '5%' }}>
              <div className="connect-wrapper-infodiv-contentdisplay-connectWrapper">
                STEP 3: PAIR YOUR DISPLAY
              </div>
              <div className="connect-wrapper-infodiv-contentdisplay-pairWrapper">
                Tap on the display icon in the smartphone app and add a display. This opens the QR code scanner. Use it to scan the QR code on the right to pair your display with your smartphone.
              </div>
            </div>
          ) : null}
          {/* last Step */}
          {this.state.step === 'step7' ? (
            <div className="connect-wrapper-infodiv-contentdisplay">
              <div className="connect-wrapper-infodiv-contentdisplay-connectWrapper">
                STEP 4: PLAY AN ARTWORK
              </div>
              <div className="connect-wrapper-infodiv-contentdisplay-pairWrapper">
                Play the art you want to see on your display. You can also use the app to manage your collections.
              </div>
            </div>
          ) : null}
          <div className="connect-wrapper-infodiv-contentdisplay-buttonWrapper" style={this.state.step === 'step4' || this.state.step === 'step5' || this.state.step === 'step6' ? {marginLeft: '5%'} : {marginLeft: '12%'}}>
            <button className="connect-wrapper-infodiv-contentdisplay-buttonWrapper-btn" ref="back">{this.backButtonText}</button>
            <button className="connect-wrapper-infodiv-contentdisplay-buttonWrapper-btn" ref="next">{this.nextButtonText}</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  mobileDeviceId: (mobileId) => dispatch(mobileDeviceId(mobileId)),
  fetchDevice: (deviceId) => dispatch(fetchDevice(deviceId)),
  fetchUser: () => dispatch(fetchUser()),
  fetchSubscription: () => dispatch(fetchSubscription()),
  fetchFeaturedPlaylist: () => dispatch(fetchFeaturedPlaylist()),
  fetchMyPlaylist: () => dispatch(fetchMyPlaylist()),
  fetchFollowedCollection: () => dispatch(fetchFollowedCollection()),
  fetchHomePlaylist: () => dispatch(fetchHomePlaylist()),
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
});
export default connect((state) => {
  const { app } = state;
  return {
    app,
  };
}, mapDispatchToProps)(Connect);
